import { render, staticRenderFns } from "./Announce.vue?vue&type=template&id=6d60bee6&scoped=true"
import script from "./Announce.vue?vue&type=script&lang=js"
export * from "./Announce.vue?vue&type=script&lang=js"
import style0 from "./Announce.vue?vue&type=style&index=0&id=6d60bee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d60bee6",
  null
  
)

export default component.exports